import * as React from 'react';
import { X } from 'lucide-react';
import { Badge, type BadgeProps } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export interface RemovableBadgeProps {
  children: React.ReactNode;
  onRemove: () => void;
  /** Complete accessible name of the remove control, e.g. `${tag} — 削除`. */
  removeLabel: string;
  variant?: BadgeProps['variant'];
  className?: string;
}

const RemovableBadge: React.FC<RemovableBadgeProps> = ({
  children,
  onRemove,
  removeLabel,
  variant = 'secondary',
  className,
}) => (
  <Badge variant={variant} className={cn('gap-1 pr-1 font-normal leading-[1.5]', className)}>
    {children}
    <button
      type="button"
      aria-label={removeLabel}
      onClick={onRemove}
      /* The explicit box is the hit area: index.css zeroes button padding inside
         .revy-ui, so without a sized grid the X would have no room around it. */
      className="grid size-4 place-items-center rounded-full text-muted-foreground transition-colors hover:bg-background hover:text-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring"
    >
      <X className="size-3" strokeWidth={2.4} />
    </button>
  </Badge>
);

export { RemovableBadge };
